import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScanPointsColorDirective } from './scan-points-color.directive';

@NgModule({
  declarations: [
    ScanPointsColorDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ScanPointsColorDirective,
  ]
})
export class ScanPointsColorModule { }
